import {createContext, useContext} from 'react'

export const ModalManagerContext = createContext()
export const useOpenModal = () => useContext(ModalManagerContext)
